import { render, staticRenderFns } from "./PricingForSpecialGroupsSection.vue?vue&type=template&id=6dd5e04b&scoped=true"
import script from "./PricingForSpecialGroupsSection.vue?vue&type=script&lang=js"
export * from "./PricingForSpecialGroupsSection.vue?vue&type=script&lang=js"
import style0 from "./PricingForSpecialGroupsSection.vue?vue&type=style&index=0&id=6dd5e04b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd5e04b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd5e04b')) {
      api.createRecord('6dd5e04b', component.options)
    } else {
      api.reload('6dd5e04b', component.options)
    }
    module.hot.accept("./PricingForSpecialGroupsSection.vue?vue&type=template&id=6dd5e04b&scoped=true", function () {
      api.rerender('6dd5e04b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/PricingForSpecialGroups/PricingForSpecialGroupsSection.vue"
export default component.exports